module.exports = __webpack_public_path__ + "static/img/icon_group_2.e0cb1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/icon_group_2.png
// module id = jAyK
// module chunks = 0